/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import { format } from "date-fns";
import Container from "../components/Container";
import TimeSlotPicker from "../components/TimeSlotPicker";
import FooterStepButton from "../components/FooterStepButton";
import NavigationHeader from "../components/NavigationHeader";
import { useBooking } from "../hooks/useBooking";
import { useTimeSlotSelection } from "../hooks/useTimeSlotSelection";
import { useMembershipCoverage } from "../hooks/useMembershipCoverage";

const DateTime = () => {
  const {
    selectedServices,
    selectedProvider,
    selectedDate,
    selectedTime,
    setSelectedDate,
    selectedLocation,
  } = useBooking();
  const { selectTimeSlot, pendingTime } = useTimeSlotSelection();
  const { minDate, maxDate } = useMembershipCoverage(selectedServices);

  // Clamp into the coverage window; skip the down-clamp when disjoint (minDate > maxDate).
  useEffect(() => {
    if (minDate && selectedDate < minDate) {
      setSelectedDate(minDate);
    } else if (maxDate && selectedDate > maxDate && (!minDate || minDate <= maxDate)) {
      setSelectedDate(maxDate);
    }
  }, [minDate, maxDate, selectedDate, setSelectedDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date instanceof Date ? format(date, "yyyy-MM-dd") : date);
  };

  const handleSlotClick = (time) => selectTimeSlot(selectedDate, time, selectedProvider);

  return (
    <Container>
      <NavigationHeader location back="step" />
      <TimeSlotPicker
        date={selectedDate}
        onDateChange={handleDateChange}
        services={selectedServices}
        provider={selectedProvider}
        location={selectedLocation}
        minDate={minDate}
        maxDate={maxDate}
        selectedTime={selectedTime}
        pendingTime={pendingTime}
        onSlotClick={handleSlotClick}
      />
      {selectedDate && selectedTime && <FooterStepButton />}
    </Container>
  );
};

export default DateTime;
